import { HttpClient } from '../httpClient';
import DisciplineGroup from '../models/disciplineGroup';
import DisciplineGroupsResponse from '../responses/disciplineGroupsResponse';
import DisciplineGroupResponse from '../responses/disciplineGroupResponse';
import { BaseResponse } from '../responses/baseResponse';

const httpClient = new HttpClient();

export const getDisciplineGroups = async () => {
  return httpClient.get<DisciplineGroupsResponse>({
    url: '/v1/disciplines/groups',
    requiresToken: true,
  });
};

export const getDisciplineGroup = async (disciplineGroupId: number) => {
  return httpClient.get<DisciplineGroupResponse>({
    url: `/v1/disciplines/groups/${disciplineGroupId}`,
    requiresToken: true,
  });
};

export const createDisciplineGroup = async (
  disciplineGroup: DisciplineGroup
) => {
  return httpClient.post<BaseResponse>({
    url: '/v1/disciplines/groups',
    payload: disciplineGroup,
    requiresToken: true,
  });
};

export const updateDisciplineGroup = async (
  disciplineGroupId: number,
  disciplineGroup: DisciplineGroup
) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/disciplines/groups/${disciplineGroupId}`,
    payload: disciplineGroup,
    requiresToken: true,
  });
};

export const deleteDisciplineGroup = async (disciplineGroupId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/disciplines/groups/${disciplineGroupId}`,
    requiresToken: true,
  });
};
